import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import AccountMyInfoComponent from './MyInfoComponent';
import { updateAccount } from './Actions';
import { passwordEncode } from '../util/auth.util';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateAccount: (
      firstName: string,
      lastName: string,
      email: string,
      password: string | undefined,
      phone: string,
      isImpersonating: boolean
    ) => dispatch(updateAccount(
      firstName,
      lastName,
      email,
      password ? passwordEncode(email, password) : undefined,
      phone,
      isImpersonating
    )),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState
  };
};

const AccountMyInfo = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(AccountMyInfoComponent);

export default AccountMyInfo;


// WEBPACK FOOTER //
// ./src/account/MyInfo.tsx